const tabsUser = {
  active: 'ACTIVOS',
  invite: 'INVITACIONES',
  Typography: 'Ningún resultado encontrado'
};

export default tabsUser;
